import React, { useEffect, useState, useCallback } from "react";
import {
  Container, Card, CardBody, CardHeader, Table, Button, Badge, Spinner, Input,
} from "reactstrap";
import { listContatos } from "./contatosApi";

// Listagem dos contatos (leads / e-mails) capturados no site Oplena.
// Fonte: backend Slim do site -> GET /admin/contatos (Postgres, schema oplena).
const PAGE_SIZE = 20;

const fmtData = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d.getTime())) return String(v);
  return d.toLocaleString("pt-BR");
};

const Contatos = () => {
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [busca, setBusca] = useState("");

  const carregar = useCallback(async (p) => {
    setLoading(true);
    setErro("");
    try {
      const res = await listContatos(p, PAGE_SIZE);
      setLista(res.items || []);
      setTotal(res.total || 0);
      setPage(res.page || p);
    } catch (e) {
      setErro(e.message || "Falha ao carregar contatos.");
      setLista([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { carregar(1); }, [carregar]);

  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

  const filtrados = lista.filter((c) =>
    [c.email, c.name, c.source].join(" ").toLowerCase().includes(busca.toLowerCase())
  );

  return (
    <div className="page-content">
      <Container fluid>
        <Card>
          <CardHeader className="d-flex align-items-center justify-content-between flex-wrap gap-2">
            <div>
              <h4 className="mb-0 fw-bold">Contatos</h4>
              <small className="text-muted">{total} e-mail(s) capturado(s)</small>
            </div>
            <div className="d-flex gap-2 align-items-center">
              <Input
                type="text"
                placeholder="Filtrar na página..."
                value={busca}
                onChange={(e) => setBusca(e.target.value)}
                style={{ maxWidth: 220 }}
              />
              <Button color="outline-secondary" onClick={() => carregar(page)} disabled={loading}>
                <i className="fa-solid fa-rotate-right" />
              </Button>
            </div>
          </CardHeader>
          <CardBody>
            {erro && <div className="alert alert-danger py-2">{erro}</div>}
            {loading ? (
              <div className="text-center py-5"><Spinner /></div>
            ) : filtrados.length === 0 ? (
              <div className="text-center text-muted py-5">Nenhum contato capturado ainda.</div>
            ) : (
              <>
                <Table responsive hover className="align-middle mb-0">
                  <thead>
                    <tr>
                      <th>E-mail</th>
                      <th>Nome</th>
                      <th>Origem</th>
                      <th>Idioma</th>
                      <th>Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtrados.map((c) => (
                      <tr key={c.id}>
                        <td className="fw-semibold">{c.email}</td>
                        <td>{c.name || "—"}</td>
                        <td>
                          {c.source
                            ? <Badge color={c.source === "contato" ? "info" : "secondary"}>{c.source}</Badge>
                            : "—"}
                        </td>
                        <td>{c.locale ? c.locale.toUpperCase() : "—"}</td>
                        <td>{fmtData(c.created_at)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <div className="d-flex align-items-center justify-content-between mt-3">
                  <small className="text-muted">Página {page} de {totalPages}</small>
                  <div className="d-flex gap-2">
                    <Button
                      size="sm"
                      color="light"
                      disabled={page <= 1 || loading}
                      onClick={() => carregar(page - 1)}
                    >
                      Anterior
                    </Button>
                    <Button
                      size="sm"
                      color="light"
                      disabled={page >= totalPages || loading}
                      onClick={() => carregar(page + 1)}
                    >
                      Próxima
                    </Button>
                  </div>
                </div>
              </>
            )}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default Contatos;
